<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-usd-circle'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">予算</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">予算</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getBudgetLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>予算</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <v-checkbox v-for="(item, key) in getBudgetItems" :key="key" multiple
          v-model="form.budget.content"
          color="blue darken-2"
          :label="item"
          :value="key"
        />
      </v-col>
      <v-col cols="1" class="pl-3">
        <v-checkbox multiple hide-details class="shrink mr-2"
          v-model="form.budget.content"
          color="blue darken-2"
          value="?"
        />
      </v-col>
      <v-col cols="10" class="pr-3">
        <v-text-field :required="isSumInputtable"
          v-model="form.budget.sum"
          label="金額"
          prefix="約"
          suffix="万円"
          mask="######"
          :disabled="!isSumInputtable"
          :rules="isSumInputtable ? rules.sum : []"
        />
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.budget.note"
          label="予算の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyBudget',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        budget: {
          tba: '見当がつかない',
          guardian: '保護者の援助があるが具体的には未定'
        }
      },
      form: {
        budget: {
          id: '',
          content: [],
          note: '',
          sum: ''
        }
      },
      rules: {
        budget: [
          v => !!(v && v.length) || '必須項目です'
        ],
        sum: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.budget
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.budget.content && this.$props.data.budget.content === 'NONE'))
        this.$set(this.form, 'budget', {
          id: '' + (this.$props.data.budget.id ? this.$props.data.budget.id : 'new_budget'),
          content: this.$props.data.budget.content ? this.$props.data.budget.content.split(',').map(it => {
            return !this.meta.budget[it] ? '?' : it
          }) : [],
          sum: this.$props.data.budget.content ? this.$props.data.budget.content.split(',').filter(it => {
            return !this.meta.budget[it]
          }).join('') : '',
          note: this.$props.data.budget.note ? this.$props.data.budget.note : ''
        })
      } else {
        this.$set(this.form, 'budget', {
          id: 'new_budget',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'budget'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.budget, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['budget', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'budget'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['budget', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'budget'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.budget &&
        this.$props.data.budget.content &&
        this.$props.data.budget.content === 'NONE'
      )
    },
    isSumInputtable () {
      return !!(
        this.form.budget.content.length &&
        this.form.budget.content.includes('?')
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.budget &&
        this.$props.data.budget.content
      )
    },
    printBudget () {
      if (
        this.$props.data &&
        this.$props.data.budget &&
        this.$props.data.budget.content
      ) {
        if (this.meta.budget[this.$props.data.budget.content]) {
          return this.meta.budget[this.$props.data.budget.content]
        } else if (isFinite(this.$props.data.budget.content)) {
          return ('約' + this.$props.data.budget.content + '万円')
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    getBudgetItems () {
      return this.meta.budget
    },
    getBudgetLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.budget &&
        this.$props.data.budget.content
      ) ? this.$props.data.budget.content.split(',').map(key => {
          return this.meta.budget[key] || `約${key}万円`
        }) : []
    }
  }
}
</script>
